import {vnTemplate} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/vnTemplate";
import {DragAndDropHandler} from "../../utils/DragAndDropHandler";
import {DealsCaroussel_template} from "./DealsCaroussel_template";

declare var ko: any;

enum Edition {
    INLIST = 'inlist',
    ADD = 'add'
}
export class DealsInHubPage_template extends vnTemplate {

    protected carousselWidget: DealsCaroussel_template;
    // implementation of base class [vnTemplate]
    protected getTemplateHtml(): string {

        return `
        <div class="w-form-body no-border form-group-flex featured-pinned-section">
            
           <div class="form-body no-padding">
              <strong class="form-sub-title pinned-articles">Primary Deals</strong>
              <div class="form-group row">
                 <button class="btn secondary icon i-tag" data-bind="event: { click: onClickAddPinnedTag.bind($data, 'primaryDeals') }" type="button" style="margin-right: 1rem;">Add Primary Deal</button>
              </div>
              <ul data-bind="visible: primaryDealsErrors().length > 0, foreach: primaryDealsErrors" class="errors">
                  <li data-bind="text: $data"></li>
              </ul>

              <div class="form-group">
                  <input id="enable-caroussel-widget" type="checkbox" data-bind="checked: enableCarousselWidget" class="input-checkbox">
                  <label class="form-label icon i-check" for="enable-caroussel-widget">Enable Partner Carousel</label>
              </div>

              <div data-bind="visible: enableCarousselWidget">
                  ${this.carousselWidget.getHtmlBuild()}
              </div>
              
              <div data-bind="foreach: primaryDeals, childrenComplete: handleDragAndDrop($element, primaryDeals ,'.w-deal-draggable')" class="featured-deals-list">
                    <div class="form-body w-pinned w-deal-draggable">
                        <div class="pinned-form article-pinned entry">
                            <div class="pinned-drag icon i-drag">
                                <span class="pinned-position" data-bind="text: ($index() + 1)"></span>
                            </div>
                            <div class="w-btn">
                                <button class="btn border only-icon icon border i-edit" type="button" data-bind="event: { click: $parent.onClickPinnedDealEdit.bind($data, 'primaryDeals') }">
                                    <span class="hidden-text">Edit</span>
                                </button>
                                <button class="btn border only-icon icon border highlight i-delete" type="button" data-bind="event: { click: $parent.onClickPinnedDealDelete.bind($data, 'primaryDeals') }">
                                    <span class="hidden-text">Delete</span>
                                </button>
                            </div>
                            <div class="w-title">
                                <!-- ko if: tagImage && tagImage.src -->
                                <div class="pinned-title">
                                    <img src="" data-bind="attr: { src: tagImage.src + '?w=50&h=50', alt: tagImage.altText || 'Card image' }" style="width: 50px; height: 50px; object-fit: cover; margin-left: 5px;" />
                                </div>
                                <!-- /ko -->

                                <span class="pinned-title"><span data-bind="text: '(' + id + ') ' + title"></span></span>
                            </div>
                            <div class="no-margin">
                               <label class="form-label icon i-link">Button Text</label>
                               <input data-bind="value: dealButtonText" class="input-text" type="text">
                            </div>
                            <div class="no-margin">
                               <label class="form-label icon i-hourglass">Hours Pinned</label>
                               <input data-bind="value: pinnedHours" onkeypress="if(this.value.length==3) return false;" class="input-text number" type="number" id="" name="" min="0">
                            </div>
                            
                        </div>
                    </div>
              </div>
           </div>
           <div class="form-body no-padding">
              <strong class="form-sub-title pinned-tag">Secondary Deals</strong>
              <div class="form-group row">
                 <button class="btn secondary icon i-tag" data-bind="event: { click: onClickAddPinnedTag.bind($data, 'secondaryDeals') }" type="button" style="margin-right: 1rem;">Add Secondary Deal</button>
              </div>
              <ul data-bind="visible: secondaryDealsErrors().length > 0, foreach: secondaryDealsErrors" class="errors">
                  <li data-bind="text: $data"></li>
              </ul>
              <div data-bind="foreach: secondaryDeals, childrenComplete: handleDragAndDrop($element, secondaryDeals ,'.w-deal-draggable')" class="secondary-deals-list">
                <div class="form-body w-pinned w-deal-draggable">
                        <div class="pinned-form article-pinned entry">
                            <div class="pinned-drag icon i-drag">
                                <span class="pinned-position" data-bind="text: ($index() + 1)"></span>
                            </div>
                            <div class="w-btn">
                                <button class="btn border only-icon icon border i-edit" type="button" data-bind="event: { click: $parent.onClickPinnedDealEdit.bind($data, 'secondaryDeals') }">
                                    <span class="hidden-text">Edit</span>
                                </button>
                                <button class="btn border only-icon icon border highlight i-delete" type="button" data-bind="event: { click: $parent.onClickPinnedDealDelete.bind($data, 'secondaryDeals') }">
                                    <span class="hidden-text">Delete</span>
                                </button>
                            </div>
                            <div class="w-title">
                                <!-- ko if: tagImage && tagImage.src -->
                                <div class="pinned-title">
                                    <img src="" data-bind="attr: { src: tagImage.src + '?w=50&h=50', alt: tagImage.altText || 'Card image' }" style="width: 50px; height: 50px; object-fit: cover; margin-left: 5px;" />
                                </div>
                                <!-- /ko -->
                                
                                <span class="pinned-title"><span data-bind="text: '(' + id + ') ' + title"></span></span>
                            </div>
                            <div class="no-margin">
                               <label class="form-label icon i-link">Button Text</label>
                               <input data-bind="value: dealButtonText" class="input-text" type="text">
                            </div>
                            <div class="no-margin">
                               <label class="form-label icon i-hourglass">Hours Pinned</label>
                               <input data-bind="value: pinnedHours" onkeypress="if(this.value.length==3) return false;" class="input-text number" type="number" id="" name="" min="0">
                            </div>
                        </div>
                    </div>
              </div>
           </div>
        </div>
`;
    }

    public handleDragAndDrop(element, currentObservableArray, childrenSelector): any {

        DragAndDropHandler.handleDragAndDrop(element, currentObservableArray, childrenSelector);
    }

    // implementation of base class [vnTemplate]
    protected initPartial(): void {

        this.carousselWidget = new DealsCaroussel_template('DealsCaroussel_template', this.getTemplateViewModel(), this.caller);
    }


    // implementation of base class [vnTemplate]
    protected getTemplateName(): string {
        return 'DealsInHubPage_template';
    }


    // implementation of base class [vnTemplate]
    protected getMainElementClasses(): Array<string> {
        return [];
    }

    //
    // implementation of base class [vnTemplate]
    public buildViewModel() {

        // define the viewModel data/ functions
        let self = this;
        return {
            primaryDealsErrors: ko.observableArray([]),
            secondaryDealsErrors: ko.observableArray([]),
            primaryDeals: ko.observableArray([]),
            secondaryDeals: ko.observableArray([]),
            editionSource: ko.observable(Edition.ADD),
            enableCarousselWidget: ko.observable(false),
            handleDragAndDrop: function (element, currentObservableArray, childrenSelector) {
                self.handleDragAndDrop(element, currentObservableArray, childrenSelector);
            },
            onClickAddPinnedTag: (dealType, data, event) => {

                self.onClickAddPinnedTag(dealType);
            },
            onClickPinnedDealEdit: (dealType, data, event) => {

                self.onClickPinnedDealEdit(dealType, data);
            },
            onClickPinnedDealDelete: (dealType, data, event) => {

                self.onClickPinnedDealDelete(dealType, data);
            },
        };
    }

    public setPrimaryDealsErrors(errors) {
        this.getTemplateViewModel().primaryDealsErrors(errors);
    }

    public setSecondaryDealsErrors(errors) {
        this.getTemplateViewModel().secondaryDealsErrors(errors);
    }

    public setDefaultEditionSource() {
        this.setEditionSource(Edition.ADD);
    }
    public setEditionSource(source) {
        this.getTemplateViewModel().editionSource(source);
    }
    public getEditionSource() {
        return this.getTemplateViewModel().editionSource();
    }

    public isInListEditionSource() {
        let editionSource = this.getEditionSource();

        return (editionSource === Edition.INLIST);
    }

    public isAddEditionSource() {
        let editionSource = this.getEditionSource();

        return (editionSource === Edition.ADD);
    }

    public getPrimaryDeals() {
        return this.getTemplateViewModel().primaryDeals();
    }

    public setPrimaryDeals(deals) {

        deals.forEach((deal, index) => {
            if (!deal.dealButtonText) {
                deal.dealButtonText = null;
            }
        });
        this.getTemplateViewModel().primaryDeals(deals);
    }

    public setSecondaryDeals(deals) {
        deals.forEach((deal, index) => {
            if (!deal.dealButtonText) {
                deal.dealButtonText = null;
            }
        });
        this.getTemplateViewModel().secondaryDeals(deals);
    }

    public getSecondaryDeals() {
        return this.getTemplateViewModel().secondaryDeals();
    }

    public getEnableCarousselWidget() {

        return this.getTemplateViewModel().enableCarousselWidget();
    }

    public setEnableCarousselWidget(enableCarousselWidget): void {

        this.getTemplateViewModel().enableCarousselWidget(enableCarousselWidget);
    }

    public getDealsData() {

        let dealsData = {
            primaryDeals: this.getPrimaryDeals(),
            secondaryDeals: this.getSecondaryDeals(),
            enableCaroussel: this.getEnableCarousselWidget(),
        };

        if (this.getEnableCarousselWidget()) {
            dealsData["carousselData"] = this.carousselWidget.buildCarousselData()
        }

        return dealsData;
    }

    public addPrimaryDeal(deal) {

        let dealInfo = this.isDealAlreadyInList(deal);
        if (dealInfo.exists) {
            if (this.isAddEditionSource()) {
                this.setSecondaryDealsErrors([]);
                this.setPrimaryDealsErrors([dealInfo.message]);
            } else {
                let primaryDeals = this.getPrimaryDeals();
                if (dealInfo.index !== -1) {
                    primaryDeals.splice(dealInfo.index, 1, deal);
                    this.setPrimaryDeals(primaryDeals);
                }
            }
        } else {
            let primaryDeals = this.getPrimaryDeals();
            primaryDeals.push(deal);
            this.setPrimaryDeals(primaryDeals);
        }
    }

    public addSecondaryDeal(deal): void {

        let dealInfo = this.isDealAlreadyInList(deal);
        if (dealInfo.exists) {
            if (this.isAddEditionSource()) {
                this.setPrimaryDealsErrors([]);
                this.setSecondaryDealsErrors([dealInfo.message]);
            } else {
                let secondaryDeals = this.getSecondaryDeals();
                if (dealInfo.index !== -1) {
                    secondaryDeals.splice(dealInfo.index, 1, deal);
                    this.setSecondaryDeals(secondaryDeals);
                }
            }
        } else {
            let secondaryDeals = this.getSecondaryDeals();
            secondaryDeals.push(deal);
            this.setSecondaryDeals(secondaryDeals);
        }
    }

    public isDealAlreadyInList(deal) {
        let dealInfo = {index: null, exists: false, message: ''};
        let pds = this.getPrimaryDeals();

        const i = pds.findIndex(pd => pd.id === deal.id);
        if (i !== -1) {

            let title = deal.name;
            if (deal.titleOverride) {
                title = deal.titleOverride;
            }
            dealInfo =   {
                index: i,
                exists: true,
                message: `${title} (${deal.id}) is already in the primary list.`
            };
        }

        let sds = this.getSecondaryDeals();
        const j = sds.findIndex(pd => pd.id === deal.id);
        if (j !== -1) {
            let title = deal.name;
            if (deal.titleOverride) {
                title = deal.titleOverride;
            }
            dealInfo =   {
                index: j,
                exists: true,
                message: `${title} (${deal.id}) is already in the secondary list.`
            };
        }

        return dealInfo;
    }

    public onClickAddPinnedTag(dealType) {

        this.setEditionSource(Edition.ADD);

        this.caller.showTagPickerForDeals('single-select', dealType);
    }

    public onClickPinnedDealEdit(dealType, data) {

        this.setEditionSource(Edition.INLIST);

        this.caller.onClickPinnedDealEdit(dealType, data);
    }

    public onClickPinnedDealDelete(dealType, deal) {

        if (dealType === 'secondaryDeals') {

            let sds = this.getSecondaryDeals();
            let fsds = sds.filter(sd => sd.id !== deal.id);
            this.setSecondaryDeals(fsds);
        } else {
            let pds = this.getPrimaryDeals();
            let fpds = pds.filter(sd => sd.id !== deal.id);
            this.setPrimaryDeals(fpds);
        }
    }

    public setCarousselWidgetData(carousselData) {

        this.carousselWidget.setImage(carousselData.logo);
        this.carousselWidget.setTitle(carousselData.title);
        this.carousselWidget.setExcerpt(carousselData.excerpt);
        this.carousselWidget.setBullet1(carousselData.bullet1);
        this.carousselWidget.setSubBullet1(carousselData.subBullet1);
        this.carousselWidget.setBullet2(carousselData.bullet2);
        this.carousselWidget.setSubBullet2(carousselData.subBullet2);
        this.carousselWidget.setBullet3(carousselData.bullet3);
        this.carousselWidget.setSubBullet3(carousselData.subBullet3);
        this.carousselWidget.setBadge(carousselData.badge);
        this.carousselWidget.setButtonLabel(carousselData.buttonLabel);
        this.carousselWidget.setButtonLink(carousselData.buttonLink);
    }

    public clearCarousselLogo() {
        this.carousselWidget.clearImage();
    }

    public setCarousselLogo(logo) {
        this.carousselWidget.setImage(logo);
    }
}



// WEBPACK FOOTER //
// ./js/components/templates/DealsInHubPage_template.ts